import config from "../config.json";
import DispatcherEvent from "./DispatcherEvent";
import {Auth} from "../offline-auth/auth";

export default class ConsultSignaler {
    constructor() {
        // property definitions
        this.events = {};
        this.wsUri = config.socket.consult.URL;
        // this.wsUri = "wss://8a7v2yzkva.execute-api.ap-southeast-1.amazonaws.com/dev";
        this.webSocket = null;
        this.isConnected = false;
        this.subscribers = [];
        this.reConnect = false;
        this.uid = null;
        this.isBusy = false;
    }

    dispatch(eventName, data) {
        const event = this.events[eventName];
        if (event) {
            event.fire(data);
        }
    }

    on(eventName, callback) {
        let event = this.events[eventName];
        if (!event) {
            event = new DispatcherEvent(eventName);
            this.events[eventName] = event;
        }
        event.registerCallback(callback);
    }

    off(eventName, callback) {
        const event = this.events[eventName];
        if (event && event.callbacks.indexOf(callback) > -1) {
            event.unregisterCallback(callback);
            if (event.callbacks.length === 0) {
                delete this.events[eventName];
            }
        }
    }

    onOpen = (event) => {
        console.log("Websocket Open", event);
        this.isConnected = true;
        // this.dispatch('connected', event.data);

        // if(this.reConnect && this.uid) {
        //     this.subscribers.forEach((subscriber) => {
        //         this.subscribeOnlineStatus(subscriber, this.uid);
        //     });
        //     this.reConnect = false;
        // }
    }

    onClose = (event) => {
        console.log("Websocket Closed", event, this);
        this.isConnected = false;
        // // this.uid = null;
        // this.dispatch('off-subscribe', event.data);
        // this.dispatch('closed-ws', event.data);
        // console.log("sub ==== ", sessionStorage.getItem('sub'));
        if (localStorage.getItem('sub')) {
            this.init(this.uid, this.role, true);
            // setTimeout(() => {
            //     this.init(this.uid, this.role, true);
            // }, 200);
        } 
        // else {
        //     Auth.signOut();
        // }
    }

    onMessage = (event) => {
        console.log("Websocket onMessage", event.data);
        const data = JSON.parse(event.data);
        switch (data.command) {
            case "ENTERWR": this.dispatch(`wrstatus${data.body.apptId}`, data.body.senderId);
                break;
            case "EXITWR": this.dispatch(`wrstatus${data.body.apptId}`, null);
                break;
            case "CALLREQ": this.dispatch('recive-call', data.body);
                break;
            case "DECLINEREQ": this.dispatch('decline-request');
                break;
            case "CANCELREQ": this.dispatch('cancel-call');
                break;
            case "ACCEPTREQ": this.dispatch('accept-call');
                break;
            case "DECLINEREQ_ACK": this.dispatch('decline-request-ack');
                break;
            case "CANCELREQ_ACK": this.dispatch('cancel-call-ack');
                break;
            case "ACCEPTREQ_ACK": this.dispatch('accept-call-ack');
                break;
            case "PENDLIST": this.dispatch('reload-pending-list');
                break;
            case "APPTSTATUS": this.dispatch(`reload-appt-list`);
                break;
            default: return;

        }
        // if(data.command === 'PRESENCE') {
        //     this.dispatch(data.uid, data.status);
        // }
        // if(data.command === 'CALLREQUEST') {
        //     // if(is)
        //     this.dispatch('oncall-receiver', data.body);
        // }

        // if(data.command === 'CALLDECLAINED') {
        //     this.dispatch('call-declained', {});
        // }

        // if(data.command === 'CALLACCEPTED') {
        //     this.dispatch('call-accepted', {selfId: data.body.remoteId, remoteId: data.body.senderId, publishVideo: true});
        // }
        // if(data.command === 'ENDCALL') {
        //     this.dispatch('oncall-ended', {});
        // }
        // if (data.command === 'INDCHAT') {
        //     console.log("store ==== ", window.store);
        //     let {store} = window;
        //     if (store.getState().dashboard.selectedUser !== data.body.createdBy) {
        //         store.dispatch(setReadCount(data.body.createdBy));
        //     } else {
        //         this.dispatch('recive-ind-chat', data.body);                
        //     }
        // }
    }

    onError = (event) => {
        console.log("Websocket Error", event)
       // sessionStorage.removeItem('sub')
       // sessionStorage.removeItem('token')
    }

    randomId = () => {
        return (Math.random() + 1).toString(36).substring(7);
    }

    init = function (uid, role, reConnect = false) {
        // console.log('uid to ', uid, role);
        try {
            let token = localStorage.getItem("token");
            let voipid = localStorage.getItem("voipid");
            let deviceToken = localStorage.getItem('deviceToken');
            try {
                let url = `${this.wsUri}?userId=${uid}&role=${role}&token=${token}&clientId=${this.randomId()}`;
                url += voipid && voipid !== '' ? `&voipId=${voipid}` : '';
                url += deviceToken && deviceToken !== '' ? `&deviceToken=${deviceToken}` : '';
                this.webSocket = new WebSocket(url);
                // console.log("this.websocket==========", this.webSocket);
            } catch (err) {
                console.log("err in init ==== ", err);
            }
            this.webSocket.onopen = this.onOpen;
            this.webSocket.onclose = this.onClose;
            this.webSocket.onmessage = this.onMessage;
            this.webSocket.onerror = this.onError;
            window.webSock = this.webSocket;

            this.reConnect = reConnect;
            this.uid = uid;
            this.role = role;
        } catch (e) {
            console.log("error in signelar init ==== ", e);
            this.init(uid, role, false);
        }
    }

    enterWaitingRoom = (apptId, userId) => {
        if (this.isConnected) {
            // console.log("uid ====== ", this.uid);
            let message = {
                action: 'onMessage',
                message: 'ENTERWR',
                uid: userId,
                data: {
                    senderId: this.uid,
                    apptId: apptId

                }
            }
            // console.log("message ==== ", message);
            this.webSocket.send(JSON.stringify(message));
        }
    }

    exitWaitingRoom = (apptId, userId) => {
        if (this.isConnected) {
            // console.log("uid ====== ", this.uid);
            let message = {
                action: 'onMessage',
                message: 'EXITWR',
                uid: userId,
                data: {
                    senderId: this.uid,
                    apptId: apptId

                }
            }
            // console.log("message ==== ", message);
            this.webSocket.send(JSON.stringify(message));
        }
    }

    sendCallRequest = (doctorData, userId) => {
        if (this.isConnected) {
            doctorData['senderId'] = this.uid;
            console.log("doctorData ===== ", doctorData);
            let message = {
                action: 'onMessage',
                message: 'CALLREQ',
                uid: userId,
                data: doctorData
            }
            this.webSocket.send(JSON.stringify(message));
        }
    }

    declineCallRequest = (userId, id) => {
        if (this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'DECLINEREQ',
                uid: userId,
                data: {
                    senderId: this.uid,
                    apptId: id
                }
            }
            this.webSocket.send(JSON.stringify(message));
        }
    }

    cancelCallRequest = (userId, id) => {
        if (this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'CANCELREQ',
                uid: userId,
                data: {
                    senderId: this.uid,
                    apptId: id
                }
            }
            this.webSocket.send(JSON.stringify(message));
        }
    }

    acceptCallRequest = (userId, id) => {
        // console.log("userId ==== ", userId);
        if (this.isConnected) {
            let message = {
                action: 'onMessage',
                message: 'ACCEPTREQ',
                uid: userId,
                data: {
                    senderId: this.uid,
                    apptId: id
                }
            }
            this.webSocket.send(JSON.stringify(message));
        }
    }

    renderAppoints = (userId, msg, data = null) => {
        if (this.isConnected) {
            let message = {
                action: 'onMessage',
                message: msg,
                uid: userId,
                data: data
            }
            this.webSocket.send(JSON.stringify(message));
        }
    }

    endCall = (id) => {
        if (this.isConnected) {
            let message = {
                action: 'onMessage',
                message: "ENDCALL",
                uid: this.uid,
                data: {
                    senderId: this.uid,
                    apptId: id
                }
            }
            this.webSocket.send(JSON.stringify(message));
        }
    }
}
